import React from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const PageActionsAddButton = ({
   icon,
   linkTo,
   name
}) => (
   <Link to={linkTo}>
      <View
         display="flex"
         flexFlow="column"
         justifyContent="center"
         alignItems="center"
         width="100%"
         height="78px"
         padding="18px"
         borderRadius="3px"
         textAlign="center"
         className={css`
            cursor: pointer;

            &:hover {
               background-color: #444;
            }
         `}>
         <View
            flex="0 0 auto"
            width="18px"
            height="18px"
            marginBottom="12px">
            {icon}
         </View>
         <View flex="1 1 auto">
            <Text size="1" color="rgba(255,255,255,0.8)" weight="medium">
               {name}
            </Text>
         </View>
      </View>
   </Link>
)

PageActionsAddButton.propTypes = {
   icon: PropTypes.node.isRequired,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired
}

export default PageActionsAddButton
